import React from "react";
import { CreateDisconnectionRequest } from "./create";
import { Tabs } from "@shared/ui/tabs";
import { PageHeader } from "@shared/components/PageHeader";
import CreateBulkDisconnectRequest from "./bulkDisconnection/create";

const DisconnectLanding: React.FC = () => {
  const urlMapping = {
    singleRequest: "singleRequest",
    bulkRequest: "bulkRequest",
  };
  const tabComponents = {
    singleRequest: {
      label: "Single Request",
      component: <CreateDisconnectionRequest />,
    },
    bulkRequest: {
      label: "Bulk Request",
      component: <CreateBulkDisconnectRequest />,
    },
  };
  return (
    <div>
      <div>
        <PageHeader
          title="Create Disconnection Request"
          subtitle="Complete the following steps to submit a disconnection request."
        />
      </div>
      <div className="mt-2 space-y-4">
        <Tabs
          defaultValue="singleRequest"
          className="w-full"
          tabsListClassName="inline-flex w-fit bg-gradient-to-r from-blue-100/50 to-indigo-100/50 shadow-sm"
          urlMapping={urlMapping}
          tabComponents={tabComponents}
          level={0} // Top-level tabs
        />
      </div>
    </div>
  );
};

export default DisconnectLanding;
